<template>
  <a-cascader 
      :options="address" 
      :value="val" 
      :fieldNames="{ label: 'name', value: 'name', children: 'children' }" 
      @change="change" />
</template>
<script setup lang="ts">
import { computed } from 'vue'
import address from '@scripts/address.json'

const props = defineProps<{
  province: string,
  city: string,
  area: string
}>()
const emit = defineEmits(['update:province','update:city','update:area'])

const val = computed(() => {
  return [props.province, props.city, props.area]
})

const change = (name: string[]) => {
  emit('update:province', name[0])
  emit('update:city', name[1])
  emit('update:area', name[2])
}
</script> 